import { z } from 'zod';

export const RefCarrierContactType = z.object({
  refCarrierContactTypeID: z.number(),
  type: z.string(),
});

export type RefCarrierContactType = z.infer<typeof RefCarrierContactType>;
